import {
  FETCH_MERCHANT_BEGIN,
  FETCH_MERCHANT_SUCCESS,
  FETCH_MERCHANT_FAILURE,
  FETCH_MERCHANT_CURRENCY,
  FETCH_VIPTIERS_BEGIN,
  FETCH_VIPTIERS_SUCCESS,
  FETCH_VIPTIERS_FAILURE,
  FETCH_MEMBERSSHIPPROGRAM_BEGIN,
  FETCH_MEMBERSSHIPPROGRAM_SUCCESS,
  FETCH_MEMBERSSHIPPROGRAM_FAILURE,
  FETCH_LIMITEDTIMEOFFERPROGRAM_BEGIN,
  FETCH_LIMITEDTIMEOFFERPROGRAM_SUCCESS,
  FETCH_LIMITEDTIMEOFFERPROGRAM_FAILURE,
} from "../actions/constants/constants";

const MERCHANT_STATE = {
  loading: true,
  merchant: {},
  currencySymbol: "",
  vipTeirs: [],
  sortedVipTeirs: [],
  membershipProgram: {},
  limitedTimeOfferProgram: {},
  error: null,
};

const MerchantReducer = (state = MERCHANT_STATE, action) => {
  switch (action.type) {
    case FETCH_MERCHANT_BEGIN:
      return { ...state, loading: true, error: null };
    case FETCH_MERCHANT_SUCCESS:
      return {
        ...state,
        loading: false,
        merchant: action.payload,
      };
    case FETCH_MERCHANT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        merchant: {},
      };
    case FETCH_MERCHANT_CURRENCY:
      return {
        ...state,
        loading: false,
        currencySymbol: action.payload,
      };
    //* VIP TIERS
    case FETCH_VIPTIERS_BEGIN:
      return { ...state, loading: true, error: null };
    case FETCH_VIPTIERS_SUCCESS:
      const sortedVipTeirs = Array.isArray(action.payload)
        ? action.payload
            ?.filter((vipTeir) => vipTeir?.status === "active")
            ?.sort((a, b) => (b?.precedence || 0) - (a?.precedence || 0))
        : [];
      return {
        ...state,
        loading: false,
        vipTeirs: action.payload,
        sortedVipTeirs,
      };
    case FETCH_VIPTIERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        vipTeirs: [],
        sortedVipTeirs: [],
      };
    //* MEMBERSHIP PROGRAM
    case FETCH_MEMBERSSHIPPROGRAM_BEGIN:
      return { ...state, loading: true, error: null };
    case FETCH_MEMBERSSHIPPROGRAM_SUCCESS:
      return {
        ...state,
        loading: false,
        membershipProgram: action.payload,
      };
    case FETCH_MEMBERSSHIPPROGRAM_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        membershipProgram: {},
      };
    //* LIMITED TIME OFFER PROGRAM
    case FETCH_LIMITEDTIMEOFFERPROGRAM_BEGIN:
      return { ...state, loading: true, error: null };
    case FETCH_LIMITEDTIMEOFFERPROGRAM_SUCCESS:
      return {
        ...state,
        loading: false,
        limitedTimeOfferProgram: action.payload,
      };
    case FETCH_LIMITEDTIMEOFFERPROGRAM_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        limitedTimeOfferProgram: {},
      };
    default:
      return {
        ...state,
      };
  }
};

export default MerchantReducer;
